import { IInformationMessage } from "@faire/web-api--source/indigofair/data/IInformationMessage";
import { IProductPromoMessagesResponse } from "@faire/web-api--source/indigofair/data/IProductPromoMessagesResponse";

import { IProductPromotionsData } from "./interfaces";

export const getProductPromotionState = (
  data: IProductPromoMessagesResponse | undefined
): IProductPromotionsData => {
  const nonFashionWeekPromos =
    data?.promo_messages?.filter(
      (promotion) =>
        promotion.type !== IInformationMessage.Type.FAIRE_FUNDED_PROMO_BANNER
    ) ?? [];

  const marketPromo = data?.promo_messages?.find(
    (promotion) => promotion.type === IInformationMessage.Type.MARKET_PROMO
  );

  const promotionStyleBanners =
    nonFashionWeekPromos?.filter(
      (promotion) => promotion.style === IInformationMessage.Style.PROMO
    ) ?? [];

  const nonPromotionStyleBanners =
    nonFashionWeekPromos?.filter(
      (promotion) => promotion.style !== IInformationMessage.Style.PROMO
    ) ?? [];

  const guaranteedFreeShippingPromo = data?.promo_messages?.find(
    (promotion) =>
      promotion.type ===
      IInformationMessage.Type.GUARANTEED_FREE_SHIPPING_THRESHOLD
  );

  return {
    productPromotions: data?.promo_messages ?? [],
    insiderLabel: data?.insider_label,
    promotionLabel: data?.promo_label,
    nonFashionWeekPromos,
    marketPromo,
    promotionStyleBanners,
    nonPromotionStyleBanners,
    guaranteedFreeShippingPromo,
  };
};
